/**
 * Changelog API — semantic change events for a project.
 */

import { apiClient } from "./client";

// -- Types --

export interface ChangeEvent {
  id: string;
  event_type: string;
  summary: string;
  detail: Record<string, unknown>;
  created_by: string;
  created_at: string;
  commit_id: string | null;
  primary_node_id: string | null;
  affected_count: number;
}

export interface ChangelogResponse {
  total: number;
  events: ChangeEvent[];
}

export interface ChangelogOptions {
  limit?: number;
  offset?: number;
  eventTypes?: string[];
  since?: string;
  until?: string;
}

// -- API functions --

export function fetchChangelog(
  projectId: string,
  branch: string,
  options: ChangelogOptions = {},
): Promise<ChangelogResponse> {
  const params = new URLSearchParams({
    project_id: projectId,
    branch,
  });
  if (options.limit) params.set("limit", String(options.limit));
  if (options.offset) params.set("offset", String(options.offset));
  if (options.eventTypes?.length)
    params.set("event_types", options.eventTypes.join(","));
  if (options.since) params.set("since", options.since);
  if (options.until) params.set("until", options.until);

  return apiClient<ChangelogResponse>(`/changelog/?${params}`);
}

export function fetchNodeChangelog(
  nodeId: string,
  projectId: string,
  branch = "main",
  limit = 20,
): Promise<ChangeEvent[]> {
  const params = new URLSearchParams({
    project_id: projectId,
    branch,
    limit: String(limit),
  });
  return apiClient<ChangeEvent[]>(`/changelog/node/${nodeId}?${params}`);
}
